/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getAirports } from "api/services/common";
import { IAirportOption } from "types/Common";
import { commonQueryKeys } from "./commonQueryKeys";

export function useGetAirports(airportQuery: string, options?: UseQueryOptions<IAirportOption[]>) {
  return useQuery({
    queryKey: commonQueryKeys.airports(airportQuery),
    queryFn: () => getAirports(airportQuery).then((res) => res.data.results),
    refetchOnMount: false,
    enabled: airportQuery.length >= 2,
    staleTime: 60 * 1000, // 1 minute
    ...options,
  });
}
